import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import "./mobileVerificationModal.css";
import ThemeButton from "../ThemeButton/ThemeButton";
import InputComponent from "../InputComponent/InputComponent";
import constants from "../../constants/contentFile.json";
const MobileVerificationModal = ({
  className,
  handleCancel,
  handleSubmit,
  show,
  buttonText,
  cancelText,
  title,
  subTitle,
  code,
  setCode,
  otpBox,
  resendCode,
  error,
  handleChange,
  value,
}) => {
  const inputRefs = useRef([]);

  const handleInputChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      // Allow only numbers
      const updatedCode = [...code];
      updatedCode[index] = value;
      setCode(updatedCode);

      // Move focus to the next input
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      // Move focus to the previous input on backspace
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").slice(0, 6); // Limit to 6 characters
    const updatedCode = pasteData
      .split("")
      .map((char) => (/\d/.test(char) ? char : ""));
    setCode(updatedCode);

    // Move focus to the appropriate input
    updatedCode.forEach((_, i) => {
      if (inputRefs.current[i]) inputRefs.current[i].focus();
    });
  };
  return (
    <div>
      <Modal show={show} className={`alertBoxModal popupAlert ${className}`}>
        <div className="otp-modal">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
            <div className="modalBody">{subTitle}</div>
          </Modal.Header>
          <Modal.Body>
            {!otpBox && (
              <div className="mobile-input">
                <InputComponent
                  placeholder={"Enter Phone Number "}
                  onChange={handleChange}
                  value={value}
                />
                {error && <div className="error">{error}</div>}
              </div>
            )}

            {otpBox && (
              <div>
                <div className="mobile-otp inputGroup" onPaste={handlePaste}>
                  {code?.map((num, index) => (
                    <input
                      key={index}
                      type="text"
                      value={num}
                      maxLength="1"
                      ref={(el) => (inputRefs.current[index] = el)}
                      onChange={(e) => handleInputChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className={`mfaInput ${num ? "filled" : ""}`}
                    />
                  ))}
                </div>
                <div className="no-otp-code">
                  <div className="no-otp">
                    {constants.mobileVerification.dontHaveOtp}
                  </div>
                  <div className="resend-code" onClick={resendCode}>
                    {constants.mobileVerification.resendOtp}
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="buttonOk">
              <div className="cancelBtns">
                <ThemeButton
                  value={cancelText ? cancelText : "Cancel"}
                  onClick={handleCancel}
                ></ThemeButton>
              </div>
              <ThemeButton
                value={buttonText}
                onClick={handleSubmit}
                disabled={!otpBox && (error || !value)}
              />
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default MobileVerificationModal;
